var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"-6.1 -4.1 12.2 13.2","fill":"none","width":"100%","height":"100%"}},[_c('path',{attrs:{"d":"M 0 9 L 6 -4 L 0 -0.25 L -6 -4 Z","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }